import { c as _c } from "react/compiler-runtime";
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
import { PartnerCategories } from '@/types/partners';
export function usePartnersCategoriesQuery() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: QUERY_KEYS.partnersCategories(),
      queryFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
async function _temp() {
  const res = await apiSelfCareFetcher(URLS.partnersCategories);
  if (!res.json) {
    throw new Error("No data returned");
  }
  return res.json;
}